import ServicesSection from "../components/ServicesSection";

function Services() {
  return <ServicesSection />;
}

export default Services;
